import { getConfig } from '@edx/frontend-platform';
import React, { useState } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import './index.scss';
import messages from './messages';

const MaintenanceNoticeModal = () => {
  const shouldDisplayModal = (
    !localStorage.getItem('maintenance-notice-modal')
    && getConfig().SHOW_MAINTENANCE_NOTICE_MODAL
  );
  const [showModal, setShowModal] = useState<boolean>(shouldDisplayModal);
  const intl = useIntl();

  const handleCloseModal = () => {
    setShowModal(false);
    localStorage.setItem('maintenance-notice-modal', 'off');
  };

  if (!showModal) {
    return null;
  }

  return (
    <div className="maintenance-notice-modal">
      <div className="maintenance-notice-modal-overlay" />
      <div className="maintenance-notice-modal-content">
        <div className="maintenance-notice-modal__title">
          {intl.formatMessage(messages.title)}
        </div>
        <div className="maintenance-notice-modal__text">
          {intl.formatMessage(messages.text)}
        </div>
        <div className="maintenance-notice-modal__button">
          <button type="button" className="course-btn" onClick={handleCloseModal}>
            {intl.formatMessage(messages.buttonText)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceNoticeModal;
